import React from "react";
import NavigationBar from "../components/Navigationbar";
import Footer from "../components/Footer";

export default () => (
  <div>
    <NavigationBar />
    <h1>Projects</h1>
    <Footer />
  </div>
);
